import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  @Input() form: FormGroup;
  relativePathToUploadedFiles: string = 'uploaded-files'

  constructor() {}

  ngOnInit(): void {
  }

  formatDate(date) {
    return new Date(date).toLocaleDateString();
  }

  printToPdf() {
    let printContents: any, popupWin: any;
		printContents = document.getElementById('summary-page').innerHTML;
		popupWin = window.open('', '', 'top=0,left=0,height=100%,width=auto');
    if(popupWin){
			popupWin.document.open();
			popupWin.document.write(`
				<html>
					<head>
            <title>Incident ${this.form.get('incidentId').value}</title>
            <style type="text/css">
              .pdf-btn {
                display: none;
              }
              .summary{
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 100%;
              }
              .titles-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 50px;

              }
              .title-div {
                display: flex;
                align-items: center;
                gap: 8px;
              }
              .second-title {
                font-family: Public Sans;
                font-size: 26px;
                font-weight: 400;
                line-height: 24px;
                color: #565656;
                padding-left: 15px;
              }
              .card {
                width: calc(100% - 54px);
                border: 1px solid #e0e0e0;
                padding: 0 12px 12px 12px;
                margin: 4px 0;
              }
              .top-row {
                display: flex;
                justify-content: space-between;
                width: 100%;
                flex-wrap: wrap;
                padding-top: 12px;
              }
              .title-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 16px;
              }
              .title {
                font-family: 'Public Sans';
                font-size: 16px;
                font-weight: 700;
              }
              .detail-row {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                flex-wrap: wrap;
                gap: 8px;
                padding-bottom: 8px;
              }
              .detail-row .grey-row {
                background-color: #F5F5F5;
                padding: 16px;
              }
              .detail-row .gap {
                margin: 4px 0;
              }
              .detail-col {
                display: flex;
                flex-direction: column;
                gap: 2px;
                width: 24%;
              }
              .label {
                font-family: 'Public Sans';
                font-size: 12px;
                display: flex;
                flex-direction: row;
                align-items: center;
              }
              .check-icon {
                font-size: 15px;
                color: #6087D1;
                display: flex;
                flex-direction: column;
                flex-direction: column-reverse;
                justify-content: center;
                transform: translateY(-1px);
                display: none;
              }
              .info {
                font-family: 'Public Sans';
                font-size: 12px;
                font-weight: 700;
              }
              .section-title {
                padding-top: 12px;
                border-bottom: 1px solid grey;
                margin-bottom: 16px;
                padding-bottom: 8px;
                font-family: Public Sans;
                font-size: 14px;
                font-weight: 700;
                line-height: 21.15px;
              }


              .detail-section {
                width: calc(100% - 32px);
                display: flex;
                flex-direction: column;
              }
              .grey-container {
                background-color: #F5F5F5;
                padding: 16px 16px 0 16px;
              }
              .grey-container .sub-title {
                padding-top: 40px;
              }
              .sub-title {
                font-family: 'Public Sans';
                font-size: 16px;
                font-weight: 700;
                padding: 16px 0 16px 0;
              }
              .numbered-row {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                gap: 16px;
              }
              .number {
                font-family: 'Public Sans';
                font-size: 14px;
                font-weight: 700;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 14px;
                width: 14px;
                background-color: #6087D1;
                border-radius: 4px;
                color: white;
              }
              .info {
                font-family: 'Public Sans';
                font-size: 12px;
                font-weight: 700;
              }
              .category-col {
                display: flex;
                flex-direction: column;
              }
              .media-list {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
              }
              .media-container {
                display: flex;
                flex-direction: column;
                gap: 8px;
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                padding: 16px;
                width: 40%;
              }
              .label {
                font-family: 'Public Sans';
                font-size: 12px;
              }
              .info {
                font-family: 'Public Sans';
                font-size: 12px;
                font-weight: 700;
              }
              .row {
                align-items: flex-start;
                gap: 16px;
              }
              .media-card {
                display: flex;
                width: 100px;
                height: 100px;
                overflow: hidden;
              }
              .media-card img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              .title-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 16px;
                padding-bottom: 8px;
              }
              .title {
                font-family: 'Public Sans';
                font-size: 16px;
                font-weight: 700;
              }
              .chip {
                border-radius: 8px;
                padding: 2px 8px;
              }
              .finalized {
                color: white;
                background-color: #4CAF50;
                border: 1px solid #4CAF50;
              }
              .draft {
                background-color: #ffdb6f;
                font-weight: 500;
              }
              .note {
                word-wrap: break-word;
                white-space: pre-line;
              }
              .wide {
                width: 100%;
              }
              .row {
                display: flex;
                flex-direction: row;
              }
              .media-info {
                width: 100%;
              }
              .pagebreak {
                page-break-before: always;
              }
              .only-web {
                display: none;
              }
            </style>
            <body onload="window.print();window.close()">${printContents}</body>
          </head>
        </html>
      `)
      popupWin.document.close();
    }
  }
}
